// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media print {
  .post-analysis-options .button {
      display: none !important; /* Completely hide buttons */
  } 
  .or-text{
    display: none !important; /* Completely hide 'or' text */
  }
  .analysis-information {
    page-break-inside: avoid; /* Prevent page break inside */
  }
  .result-block {
    page-break-inside: avoid; /* Prevent page break inside */
  }
  .printButton {
    display: none; /* Hide print button during printing */
  }
  .feature-count-selector{
    display: none !important;
  }
  .show-analysis-results {
    padding: 20px !important;
    padding-top: 0 !important;
    display: flex !important; 
    flex-direction: column !important;
    align-items: flex-start !important;
    gap: 5px !important; /* Space between sections */
    margin-top: 0px !important; /* Smaller margin-top for printing */
  }
}

.run-analysis-section{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  animation: fadeIn 0.5s ease-in-out;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

.run-analysis-button {
  background-color: #28a745; /* More visible with green color */
  color: white;
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 12px 25px;
  margin-left: 0%;
  border-radius: 5px;
  width: auto; /* Let content define width to prevent truncation */
  min-width: 180px; /* Reasonable minimum so text always fits */
  white-space: nowrap; /* Keep label on one line */
  border: none;
  cursor: pointer;
  font-size: 18px;
  font-weight: bold;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.run-analysis-button:hover {
    background-color: #218838; /* Darker green on hover */
    box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15);
    transform: translateY(-2px);
}
`, "",{"version":3,"sources":["webpack://./src/css/step7-runAnalysis.css"],"names":[],"mappings":"AAAA;EACE;MACI,wBAAwB,EAAE,4BAA4B;EAC1D;EACA;IACE,wBAAwB,EAAE,8BAA8B;EAC1D;EACA;IACE,wBAAwB,EAAE,8BAA8B;EAC1D;EACA;IACE,wBAAwB,EAAE,8BAA8B;EAC1D;EACA;IACE,aAAa,EAAE,sCAAsC;EACvD;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;IACxB,yBAAyB;IACzB,wBAAwB;IACxB,iCAAiC;IACjC,kCAAkC;IAClC,mBAAmB,EAAE,2BAA2B;IAChD,0BAA0B,EAAE,oCAAoC;EAClE;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,yBAAyB,EAAE,kCAAkC;EAC7D,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,WAAW,EAAE,mDAAmD;EAChE,gBAAgB,EAAE,2CAA2C;EAC7D,mBAAmB,EAAE,2BAA2B;EAChD,YAAY;EACZ,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;IACI,yBAAyB,EAAE,0BAA0B;IACrD,yCAAyC;IACzC,2BAA2B;AAC/B","sourcesContent":["@media print {\n  .post-analysis-options .button {\n      display: none !important; /* Completely hide buttons */\n  } \n  .or-text{\n    display: none !important; /* Completely hide 'or' text */\n  }\n  .analysis-information {\n    page-break-inside: avoid; /* Prevent page break inside */\n  }\n  .result-block {\n    page-break-inside: avoid; /* Prevent page break inside */\n  }\n  .printButton {\n    display: none; /* Hide print button during printing */\n  }\n  .feature-count-selector{\n    display: none !important;\n  }\n  .show-analysis-results {\n    padding: 20px !important;\n    padding-top: 0 !important;\n    display: flex !important; \n    flex-direction: column !important;\n    align-items: flex-start !important;\n    gap: 5px !important; /* Space between sections */\n    margin-top: 0px !important; /* Smaller margin-top for printing */\n  }\n}\n\n.run-analysis-section{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 20px;\n  animation: fadeIn 0.5s ease-in-out;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(10px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.run-analysis-button {\n  background-color: #28a745; /* More visible with green color */\n  color: white;\n  margin-top: 20px;\n  margin-bottom: 20px;\n  padding: 12px 25px;\n  margin-left: 0%;\n  border-radius: 5px;\n  width: auto; /* Let content define width to prevent truncation */\n  min-width: 180px; /* Reasonable minimum so text always fits */\n  white-space: nowrap; /* Keep label on one line */\n  border: none;\n  cursor: pointer;\n  font-size: 18px;\n  font-weight: bold;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease;\n}\n\n.run-analysis-button:hover {\n    background-color: #218838; /* Darker green on hover */\n    box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15);\n    transform: translateY(-2px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
